export const faqs = [
  {
    question: {
      english: "How can I create a Snapseed QR code?",
      hindi: "मैं स्नैपसीड क्यूआर कोड कैसे बना सकता हूँ?",
    },
    answer: {
      english:
        "Open Snapseed and edit your photo. Then tap Menu > QR Look > Create QR Look. Save the QR code image that appears.",
      hindi:
        "स्नैपसीड खोलें और अपनी तस्वीर संपादित करें। फिर मेनू > QR Look > Create QR Look पर टैप करें। जो क्यूआर कोड इमेज दिखाई देती है उसे सेव करें।",
    },
  },
  {
    question: {
      english: "How can I use someone else's QR code?",
      hindi: "मैं किसी और का क्यूआर कोड कैसे इस्तेमाल करूँ?",
    },
    answer: {
      english:
        "Open your photo in Snapseed. Tap Menu > QR Look > Scan QR Look. Point your camera at the QR code and wait for it to scan.",
      hindi:
        "अपनी तस्वीर को स्नैपसीड में खोलें। मेनू > QR Look > Scan QR Look पर टैप करें। अपने कैमरे को क्यूआर कोड की ओर इशारा करें और स्कैन होने का इंतजार करें।",
    },
  },
  {
    question: {
      english: "Can I use multiple QR codes on one photo?",
      hindi: "क्या मैं एक फोटो पर कई क्यूआर कोड इस्तेमाल कर सकता हूँ?",
    },
    answer: {
      english:
        "Yes! After applying one QR code, you can scan another. Keep adding codes until you're satisfied with the look.",
      hindi:
        "हाँ! एक क्यूआर कोड लगाने के बाद, आप दूसरा स्कैन कर सकते हैं। कोड जोड़ते रहें जब तक आप लुक से संतुष्ट न हो जाएं।",
    },
  },
  {
    question: {
      english: "What if the QR code doesn't scan?",
      hindi: "क्या होगा अगर क्यूआर कोड स्कैन नहीं होता?",
    },
    answer: {
      english:
        "First, clean your camera lens. Make sure you have good lighting. Try holding your phone at different distances from the code. If it still doesn’t work, try rescanning.",
      hindi:
        "पहले, अपने कैमरा लेंस को साफ करें। सुनिश्चित करें कि आपके पास अच्छी रोशनी है। अपने फोन को कोड से विभिन्न दूरियों पर रखने की कोशिश करें। अगर यह अभी भी काम नहीं करता है, तो फिर से स्कैन करने की कोशिश करें।",
    },
  },
  {
    question: {
      english: "Will QR codes work on any photo?",
      hindi: "क्या क्यूआर कोड किसी भी तस्वीर पर काम करेगा?",
    },
    answer: {
      english:
        "Yes! You can use QR codes on any photo. However, some edits look better on certain types of photos, like some filters work better on portraits than landscapes.",
      hindi:
        "हाँ! आप किसी भी तस्वीर पर क्यूआर कोड का उपयोग कर सकते हैं। लेकिन याद रखें कि कुछ संपादन कुछ प्रकार की तस्वीरों पर बेहतर दिखते हैं, जैसे कुछ फिल्टर पोर्ट्रेट्स पर लैंडस्केप्स की तुलना में बेहतर लगते हैं।",
    },
  },
  {
    question: {
      english: "Can I share my QR codes online?",
      hindi: "क्या मैं अपने क्यूआर कोड्स ऑनलाइन शेयर कर सकता हूँ?",
    },
    answer: {
      english:
        "Yes! Save your QR code as an image and share it anywhere—on social media, messages, or email. Anyone with Snapseed can use it.",
      hindi:
        "हाँ! अपने क्यूआर कोड को एक इमेज के रूप में सेव करें और इसे कहीं भी शेयर करें - सोशल मीडिया, मैसेजेस, या ईमेल में। कोई भी जिसके पास स्नैपसीड है इसे उपयोग कर सकता है।",
    },
  },
  {
    question: {
      english: "Will QR codes work if I change my phone?",
      hindi: "क्या क्यूआर कोड्स तब भी काम करेंगे जब मैं फोन बदलूंगा?",
    },
    answer: {
      english:
        "Yes! QR codes work on any device with Snapseed installed. They’re like a universal recipe that any phone can read.",
      hindi:
        "हाँ! क्यूआर कोड्स किसी भी डिवाइस पर काम करते हैं जिसमें स्नैपसीड इंस्टॉल है। वे एक यूनिवर्सल नुस्खा की तरह हैं जिसे कोई भी फोन पढ़ सकता है।",
    },
  },
  {
    question: {
      english: "How many QR codes can I save?",
      hindi: "मैं कितने क्यूआर कोड्स सेव कर सकता हूँ?",
    },
    answer: {
      english:
        "As many as you like! Think of them as your favorite recipes. Give them helpful names like 'Sunset Glow' or 'Bright Portrait.'",
      hindi:
        "जितने चाहें! पसंदीदा नुस्खे सहेजने की तरह, आप क्यूआर कोड्स इकट्ठा कर सकते हैं। उन्हें मददगार नाम दें जैसे कि सनसेट ग्लो या ब्राइट पोर्ट्रेट।",
    },
  },
  {
    question: {
      english: "What if I make a mistake while creating a QR code?",
      hindi: "क्या होगा अगर मैं क्यूआर कोड बनाते समय गलती कर दूं?",
    },
    answer: {
      english:
        "No problem! Just start over and create a new one. Your old QR codes remain safe unless you choose to delete them.",
      hindi:
        "कोई समस्या नहीं! बस दोबारा शुरू करें और एक नया बनाएं। आपके पुराने क्यूआर कोड्स सुरक्षित रहते हैं जब तक आप उन्हें हटाने का चुनाव नहीं करते।",
    },
  },
  {
    question: {
      english: "Do QR codes affect my original photo?",
      hindi: "क्या क्यूआर कोड्स मेरी मूल तस्वीर को प्रभावित करते हैं?",
    },
    answer: {
      english:
        "No! Your original photo remains safe. QR codes only add editing instructions, like placing a clear sheet over your photo.",
      hindi:
        "नहीं! आपकी मूल तस्वीर सुरक्षित रहती है। क्यूआर कोड केवल संपादन निर्देशों को ऊपर जोड़ते हैं, जैसे कि आपकी तस्वीर पर एक स्पष्ट शीट रखना।",
    },
  },
     
  ];